<template>
  <div class="container-fluid py-4">
    <!-- 기존 코드 -->
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">학생(아동) 리스트</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.department" @change="fetchGrades()" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;" >
                    <option value="">부서 선택</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <select v-model="filters.grade" @change="fetchStudents(1)" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">반 선택</option>
                    <option value="all">전체</option>
                    <option v-for="group in grades" :key="group.id" :value="group.id">
                      {{ group.name }}
                    </option>
                  </select>
                  <input
                    v-model="filters.name"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="이름 검색"
                  />
                  <input
                    v-model="filters.phone"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="연락처 검색"
                  />
                  <input
                    v-model="filters.school"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="학교 검색"
                  />
                  <select v-model="filters.withdrawal" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="exclude">삭제 제외</option>
                    <option value="include">삭제 포함</option>
                  </select>                  
                  <button class="btn btn-light text-success me-2 mt-2 mt-sm-0" @click="fetchStudents(1)">검색</button>
                  <button class="btn btn-light text-success mt-2 mt-sm-0" @click="exportToExcel">엑셀 다운로드</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>번호</th>
                    <th>사진</th>
                    <th>이름</th>
                    <th>반</th>
                    <th>생년월일</th>
                    <th>선생님</th>
                    <th>연락처</th>
                    <th>학교</th>
                    <th>등록일</th>
                  </tr>
                </thead>
                <tbody id="memberlist_table">
                  <tr v-if="students.length === 0">
                    <td colspan="9" class="text-center">조회된 자료가 없습니다</td>
                  </tr>
                  <tr v-for="(student, index) in students" :key="student.no">
                    <td class="text-center">
                      <p>{{ (index + 1) + ((currentPage - 1) * 10) }}</p>
                    </td>
                    <td class="text-center">
                      <img
                        :src="student.photo !== null && student.photo !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${student.photo}` 
                                : student.photo2 !== null && student.photo2 !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${student.photo2}` 
                                : require('@/assets/img/noimage.png')"
                        class="avatar me-3 border-radius-lg"
                        alt="photo"
                      />
                    </td>
                    <td class="text-center name" style=" font-weight: bold; color: #0b62ff; cursor: pointer" @click="openPopup(student)">
                      <p>{{ student.name }}</p>
                    </td>
                    <td class="text-center"><p>{{ student.gradename }}</p></td>
                    <td class="text-center"><p>{{ student.birthday }}</p></td>
                    <td class="text-center"><p>{{ student.teachername }}</p></td>
                    <td class="text-center"><p>{{ student.phone }}</p></td>
                    <td class="text-center"><p>{{ student.school }}</p></td>
                    <td class="text-center"><p>{{ student.createdt }}</p></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 변경된 Pagination -->
            <div class="d-flex justify-content-center mt-4">
              <div class="text-center mb-2" v-if="totalRows > 0">
                <small class="text-muted">총 {{ totalRows }}개</small>
              </div>
              <nav aria-label="Page navigation" v-if="totalPages > 0">
                <ul class="pagination">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchStudents(currentPage - 1)">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="fetchStudents(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchStudents(currentPage + 1)">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Modal -->
    <div v-if="showPopup">
      <member-detail
        :student="selectedStudent"
        @close="closePopup"
        @save="saveStudent"
      />
    </div>
  </div>
</template>

<script>
import apiservice from "../services/apiservice";
import { saveAs } from 'file-saver';
import MemberDetail from "@/views/MemberDetail.vue";

export default {
  name: "tables",
  components: { 
    MemberDetail
  },
  data() {
    return {
      students: [],
      currentPage: 1,
      totalPages: 1,
      totalRows: 0,
      filters: {
        classid: "",
        name: "",
        phone: "",
        school: "",
        grade: "",
        department: "",
        withdrawal: "exclude",
      },
      userData: "",
      showPopup: false,
      selectedStudent: {},
      departments: [],
      grades: [],
    };
  },
  computed: {
    isSuperUser() {
      return this.$store.state.userData?.superuser === '1';
    },
    displayedPages() {
      const pages = [];
      const maxVisiblePages = 5;
      
      if (this.totalPages <= maxVisiblePages) {
        // 전체 페이지가 최대 표시 페이지 수보다 작거나 같으면 모든 페이지 표시
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // 현재 페이지 주변의 페이지만 표시
        let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = startPage + maxVisiblePages - 1;
        
        if (endPage > this.totalPages) {
          endPage = this.totalPages;
          startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      
      return pages;
    }
  },
  methods: {
    async fetchStudents(page = 1) {
      // superuser가 아닌 경우 부서가 이미 고정되어 있으므로 검증 우회
      if (this.isSuperUser && !this.filters.department && !this.filters.grade && !this.filters.name && !this.filters.phone && !this.filters.school) {
        console.warn("부서, 반 또는 검색어 중 하나 이상 선택해주세요.");
        alert("부서, 반 또는 검색어 중 하나 이상 선택해주세요.");
        return;
      }
      
      try {
        // 페이지 번호 유효성 검사
        page = parseInt(page);
        if (isNaN(page) || page < 1) page = 1;
        
        // 필터 데이터 복사
        const filterParams = { ...this.filters };
        
        // "전체" 선택 시 grade 파라미터 처리
        if (filterParams.grade === 'all') {
          filterParams.grade = '';
          filterParams.allGrades = true;
        }
        
        console.log("Fetching students with params:", { page, ...filterParams });
        
        const response = await apiservice.memberlist({
          params: { 
            page, 
            limit: 10,
            ...filterParams 
          },
        });
        
        if (response.data && response.data.data) {
          this.students = response.data.data;
          this.currentPage = parseInt(response.data.currentPage || page);
          this.totalPages = parseInt(response.data.totalPages || 1);
          this.totalRows = parseInt(response.data.totalRows || 0);
          
          // 디버깅 정보 출력
          if (response.data.debug) {
            console.log("Backend debug info:", response.data.debug);
            console.log("Total rows:", response.data.totalRows);
          }
          
          // 페이지 번호가 유효하지 않은 경우 처리
          if (this.totalPages < 1) this.totalPages = 1;
          if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
          
          console.log("Fetched students:", this.students.length);
          console.log("Current page:", this.currentPage, "Total pages:", this.totalPages);
        } else {
          console.error("Unexpected response format:", response);
          this.students = [];
          this.currentPage = 1;
          this.totalPages = 1;
        }
      } catch (error) {
        console.error("Failed to fetch students:", error);
        this.students = [];
        this.currentPage = 1;
        this.totalPages = 1;
      }
    },
    openPopup(student) {
      this.selectedStudent = { ...student };
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.selectedStudent = {};
    },
    async handleSave(updatedStudent) {
      try {
        await apiservice.updateStudent(updatedStudent);
        alert("수정 완료");
        this.closePopup();
        this.fetchStudents();
      } catch (error) {
        console.error("Error updating student:", error);
        alert("수정 중 오류 발생");
      }
    },
    async fetchGroups() {
      if (!this.filters.classid) return;
      try {
        const response = await apiservice.getGrade({
          params: { classid: this.filters.classid },
        });
        this.grade = response.data.data;
      } catch (error) {
        console.error("Failed to fetch groups:", error);
      }
    },
    async fetchDepartments() {
      try {
        const response = await apiservice.getDepartments();
        this.departments = response.data.data;
      } catch (error) {
        console.error("Failed to fetch departments:", error);
      }
    },
    async fetchGrades() {
      if (!this.filters.department) {
        this.grades = [];
        return;
      }
      
      try {        
        const response = await apiservice.getclasslist({ classid: this.filters.department });
        this.grades = response.data.data.map(grade => ({
          id: grade.grade,
          name: grade.gradename
        }));
        
        // 반 목록을 가져온 후 자동으로 "전체" 선택
        this.filters.grade = "all";
        
        // 반 목록이 변경되면 학생 목록 다시 가져오기
        this.fetchStudents(1);
      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    },
    async exportToExcel() {
      try {
        if (!this.filters.department) {
          alert('부서를 선택해주세요.');
          return;
        }
        // 부서 + useyn='Y' (withdrawal exclude) 기준으로 충분히 큰 limit으로 조회
        const params = {
          page: 1,
          limit: 10000,
          department: this.filters.department,
          grade: this.filters.grade === 'all' ? '' : this.filters.grade || '',
          withdrawal: 'exclude', // useyn='Y'
          name: this.filters.name || '',
          phone: this.filters.phone || '',
          school: this.filters.school || ''
        };
        const response = await apiservice.memberlist({ params });
        const rows = (response.data && response.data.data) ? response.data.data : [];

        // 헤더(설명 포함), groupid 제외
        const headers = [
          { key: 'no', label: 'no', desc: '순번', color: '#A9D08E' },
          { key: 'studentid', label: 'studentid', desc: '학생번호', color: '#A9D08E' },
          { key: 'classid', label: 'classid', desc: '부서코드', color: '#A9D08E' },
          { key: 'grade', label: 'grade', desc: '학년반코드', color: '#A9D08E' },
          { key: 'gradename', label: 'gradename', desc: '학년반이름', color: '#A9D08E' },
          { key: 'name', label: 'name', desc: '이름', color: '#A9D08E' },
          { key: 'sex', label: 'sex', desc: '성별', color: '#A9D08E' },
          { key: 'birthday', label: 'birthday', desc: '생년월일', color: '#A9D08E' },
          { key: 'teacherid', label: 'teacherid', desc: '선생님코드', color: '#FFD966' },   // 노랑
          { key: 'teachername', label: 'teachername', desc: '선생님', color: '#FFD966' }, // 노랑
          { key: 'phone', label: 'phone', desc: '휴대폰번호', color: '#A9D08E' },
          { key: 'parentphone', label: 'parentphone', desc: '부모님휴대폰번호', color: '#A9D08E' },
          { key: 'school', label: 'school', desc: '학교명', color: '#A9D08E' },
          { key: 'address', label: 'address', desc: '주소', color: '#A9D08E' },
          { key: 'rmk', label: 'rmk', desc: '참고사항', color: '#A9D08E' }
        ];

        const escapeHtml = (s) => String(s || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

        // HTML 테이블 생성(엑셀에서 스타일 반영됨)
        let html = '<html><head><meta charset="UTF-8"></head><body>';
        html += '<table border="1" cellspacing="0" cellpadding="5">';
        // 1행: 영문 키 (회색)
        const headerGray = '#D9D9D9';
        html += '<tr>';
        headers.forEach(h => {
          html += `<th style="background:${headerGray};font-weight:bold;">${h.label}</th>`;
        });
        html += '</tr>';
        // 2행: 한글 설명 (원래 색상 유지)
        html += '<tr>';
        headers.forEach(h => {
          html += `<th style="background:${h.color};font-weight:bold;">${h.desc}</th>`;
        });
        html += '</tr>';
        // 데이터 행
        rows.forEach(r => {
          html += '<tr>';
          headers.forEach(h => {
            html += `<td>${escapeHtml(r[h.key])}</td>`;
          });
          html += '</tr>';
        });
        html += '</table></body></html>';

        // UTF-8 인코딩 + BOM으로 한글 깨짐 방지
        const blob = new Blob(["\uFEFF" + html], { type: 'application/vnd.ms-excel;charset=utf-8' });
        const deptName = (this.departments.find(d => d.id === this.filters.department)?.name) || '부서';
        const today = new Date().toISOString().split('T')[0];
        saveAs(blob, `학생리스트_${deptName}_${today}.xls`);
      } catch (e) {
        console.error('엑셀 다운로드 오류:', e);
        alert('엑셀 다운로드 중 오류가 발생했습니다.');
      }
    }
  },
  // watch: {
  //   "filters.classid"() {
  //     this.fetchGroups();
  //   },
  // },
  async created() {
    try {
      const response = await apiservice.getdeptlist();
      this.departments = response.data.data.map(department => ({
        id: department.code,
        name: department.codename
      }));

      // 사용자 권한 확인 및 부서 고정 처리
      const userData = this.$store.state.userData;
      if (userData && userData.superuser !== '1') {
        // superuser가 1이 아닌 경우 classid 값으로 department.id 고정
        this.filters.department = userData.classid;
        // 부서 선택 후 반 목록 가져오기
        await this.fetchGrades();
        // 학생 목록 자동 조회
        this.fetchStudents(1);
      }
    } catch (error) {
      console.error("Failed to fetch department list:", error);
    }
    this.fetchGroups();
  },
};
</script>
<style scoped>
.d-flex.align-items-center {
  align-items: center;
}

.searchInput {
  text-align: center;
  width: 150px;
  background-color: white !important;
  margin-bottom: 0;
}

.btn {
  margin-bottom: 0;
}

.card-header, .card-body, .pagination {
  padding: 10px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    align-items: stretch;
  }
  .form-select, .form-control {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .searchInput {
    text-align: left;
  }
}
</style>
